module.exports = __webpack_public_path__ + "img/29.bd1fff03.png";